import * as types from './mutation-type';

export default {
  [types.SHOW_MODAL]: (state, {name, msg, redirecturl}) => {
    state.modal = Object.assign({}, {
        show: true,
        name,
        msg,
        redirecturl
      });
  },
  [types.HIDE_MODAL]: (state) => {
    state.modal = Object.assign({}, {
      show: false
    });
  }
}
